export const SECTION_ORDER = ['execution', 'cycle', 'program', 'feed', 'tlm', 'alarms', 'misc'];

export function sortHmiFields(fields) {
  const order = new Map(SECTION_ORDER.map((s, i) => [s, i]));
  return [...fields].sort((a, b) => {
    const sa = order.get(a.hmiResolved?.section) ?? 99;
    const sb = order.get(b.hmiResolved?.section) ?? 99;
    if (sa !== sb) return sa - sb;
    return (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
  });
}
